import i18n from 'i18next';
import initI18n from './init-i18n';
import { useCommonTranslation as useTranslation } from './utils';

initI18n();

export { i18n, initI18n, useTranslation };
export { createUseAppTranslation } from './utils';
export type { NamespaceKeys } from './utils';

export * from './components';
